import { ref } from 'vue';
import useStorageStore from '@/views/factory/hooks/useStorageStore';
import { getColumnWidth as getColumnWidthFun } from '@/components/BasisTable/common';

const TABLE_COLUMN_WIDTH_KEY = 'TABLE_COLUMN_WIDTH_MAP';
const TABLE_COLUMN_WIDTH_KEY_SUFFIX = '_TABLE_COLUMN_WIDTH';

type ColumnWidthMap = Record<string, number>;
interface useColumnWidthOptions {
  /**
   * 使用单独的key存储
   */
  useSeparateKey?: boolean;
}

const storageCache = useStorageStore();

export default function useColumnWidth(
  key?: string,
  options: useColumnWidthOptions = {}
) {
  const { useSeparateKey = false } = options;
  const columnWidths = ref<ColumnWidthMap>({});
  let map: Record<string, ColumnWidthMap> | ColumnWidthMap = {};
  let storageKey = '';
  const getStorageMap = () => {
    return storageCache.get(storageKey) || {};
  };

  // 获取每一列的宽度
  const getColumnWidth = (column: Recordable) => {
    return columnWidths.value[column.field] || getColumnWidthFun(column);
  };

  const loadSeparateKeyWidths = () => {
    columnWidths.value = map as ColumnWidthMap;
  };

  const loadSharedKeyWidths = () => {
    columnWidths.value = (map[key!] || {}) as ColumnWidthMap;
  };

  const saveSeparateKeyWidths = (resizeWidth: number, column: Recordable) => {
    columnWidths.value[column.field] = resizeWidth;
    storageCache.set(storageKey, columnWidths.value);
  };

  // 保存列宽（共同 key）
  const saveSharedKeyWidths = (resizeWidth: number, column: Recordable) => {
    columnWidths.value[column.field] = resizeWidth;
    storageCache.set(storageKey, {
      ...map,
      [key!]: columnWidths.value,
    });
  };
  const getStorageKey = () => {
    if (useSeparateKey) {
      return `${key}${TABLE_COLUMN_WIDTH_KEY_SUFFIX}`;
    }
    return TABLE_COLUMN_WIDTH_KEY;
  };
  const loadColumnWidth = () => {
    if (useSeparateKey) {
      loadSeparateKeyWidths();
    } else {
      loadSharedKeyWidths();
    }
  };

  const saveColumnWidths = ({ resizeWidth, column }: Recordable) => {
    if (useSeparateKey) {
      saveSeparateKeyWidths(resizeWidth, column);
    } else {
      saveSharedKeyWidths(resizeWidth, column);
    }
  };

  const init = () => {
    if (!key) return;
    storageKey = getStorageKey();
    map = getStorageMap();
    loadColumnWidth();
  };

  init();
  return {
    columnWidths,
    saveColumnWidths,
    getColumnWidth,
  };
}
